import { useState } from 'react';
import { getInitialValues as getInitialValuesUtil } from './EditHarvestSummaryModal.utils';
import { Report } from 'types/report';
import { HarvestSummaryModalTabs as Tabs } from './EditHarvestSummaryModal.props';

export const useEditHarvestSummaryModal = (report: Report | null) => {
  const [tabIndex, setTabIndex] = useState<Tabs>(Tabs.SKU_DETAIL);

  const handleChangeTab = (selectedTab: Tabs) => {
    setTabIndex(selectedTab);
  };

  const getInitialValues = (report: Report) => {
    return getInitialValuesUtil(report);
  };

  return {
    tabIndex,
    handleChangeTab,
    getInitialValues,
    INVOINCE_TAB: Tabs.INVOICING,
    ACTIVITY_HISTORY_TAB: Tabs.ACTIVITY_HISTORY,
  };
};
